import loadable from '@loadable/component';

/**
 * Code-split wrapper for InfoBottomSheet — keeps BottomSheet out of the initial bundle; it renders nothing until
 * a card opens it. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
export const InfoBottomSheet = loadable(
    /* #__LOADABLE__ */
    () => import('./InfoBottomSheet'),
    {
        resolveComponent: (components) => components.InfoBottomSheet,
        ssr: false,
    }
);
